<template>
	<div class="all-cate-zy">
		<!-- 操作按钮区域 -->
		<div class="operation-buttons">
			<el-button type="success" icon="el-icon-plus" size="mini" @click="handleCreateTransfer">
				新建出库单
			</el-button>
			<el-button type="danger" icon="el-icon-delete" size="mini" @click="handleBatchDelete"
				:disabled="selectedTransferRows.length === 0">
				批量删除
			</el-button>
			<el-button type="warning" icon="el-icon-refresh" size="mini" @click="handleRefresh">
				刷新数据
			</el-button>
		</div>

		<!-- 数据展示区域 -->
		<div class="data-section">
			<!-- 右侧图表和表格 -->
			<div class="right-section">
				<!-- 表格区域 -->
				<el-card class="table-card">
					<div class="table-header">
						<span>出库明细表</span>
						<div class="table-filter">
							<!-- 日期筛选保留 -->
						</div>
					</div>

					<div class="table-scroll-wrapper">
						<div class="table-scroll-container">
							<el-table ref="transferTable" :data="transferTableData" stripe border style="width: 100%;"
								v-loading="transferTableLoading" @selection-change="handleTransferSelectionChange"
								@row-click="handleTransferRowClick" :height="400">
								<el-table-column type="selection" width="55" align="center" />
								<el-table-column type="index" label="序号" width="60" align="center" fixed="left" />

								<!-- 状态列 -->
								<el-table-column prop="state" label="状态" width="100" align="center" fixed="left">
									<template #default="{ row }">
										<el-tag :type="getTransferStatusType(row.state)" size="small">
											{{ getTransferStatusText(row.state) }}
										</el-tag>
									</template>
								</el-table-column>

								<el-table-column prop="docNum" label="出库单号" width="140" show-overflow-tooltip
									fixed="left">
								</el-table-column>

								<!-- 其他列保持不变 -->
								<el-table-column prop="fromWarehouseName" label="调出药库" width="100" align="center">
									<template #default="{ row }">
										<el-tag size="small" :type="row.fromWarehouse === 1 ? 'warning' : 'primary'">
											{{ row.fromWarehouseName || (row.shedId === 1 ? '中药房' : '中药房') }}
										</el-tag>
									</template>
								</el-table-column>

								<el-table-column prop="toWarehouseName" label="调入药库" width="100" align="center">
									<template #default="{ row }">
										<el-tag size="small" :type="row.toWarehouse === 1 ? 'primary' : 'warning'">
											{{ row.toWarehouseName || (row.phayId === 1 ? '中药房' : '中药房') }}
										</el-tag>
									</template>
								</el-table-column>

								<el-table-column prop="busDate" label="业务日期" width="120" align="center">
									<template #default="{ row }">
										{{ formatDate(row.busDate) }}
									</template>
								</el-table-column>

								<el-table-column prop="costAmt" label="成本金额" width="100" align="right">
									<template #default="{ row }">
										¥{{ Number(row.costAmt || 0).toFixed(2) }}
									</template>
								</el-table-column>

								<el-table-column prop="saleAmt" label="零售金额" width="100" align="right">
									<template #default="{ row }">
										¥{{ Number(row.saleAmt || 0).toFixed(2) }}
									</template>
								</el-table-column>

								<el-table-column prop="createName" label="创建人" width="100">
									<template #default="{ row }">
										<el-tooltip :content="row.createName" placement="top">
											<span>{{ row.createName }}</span>
										</el-tooltip>
									</template>
								</el-table-column>

								<el-table-column prop="createTime" label="创建时间" width="160">
									<template #default="{ row }">
										{{ formatDateTime(row.createTime) }}
									</template>
								</el-table-column>

								<el-table-column prop="auditor" label="审核人" width="100">
									<template #default="{  row }">
										<el-tooltip :content="row.auditor || '--'" placement="top">
											<span>{{ row.auditor || '--' }}</span>
										</el-tooltip>
									</template>
								</el-table-column>

								<el-table-column prop="auditTime" label="审核时间" width="160">
									<template #default="{ row }">
										{{ row.auditTime ? formatDateTime(row.auditTime) : '--' }}
									</template>
								</el-table-column>

								<!-- 操作列 -->
								<el-table-column label="操作" width="220" fixed="right" align="center">
									<template #default="{ row }">
										<div class="action-buttons-container">
											<!-- 根据状态显示不同按钮 -->
											<template v-if="row.state === '0' || row.state === 0">
												<!-- 草稿状态：显示详情、修改、提交、删除按钮 -->
												<el-button type="text" size="small"
													@click="handleViewTransfer(row)">详情</el-button>
												<el-button type="text" size="small"
													@click="handleEditTransfer(row)">修改</el-button>
												<el-button type="text" size="small"
													@click="handleSubmitTransfer(row)">提交</el-button>
												<el-button type="text" size="small" class="delete-btn"
													@click="handleDeleteTransfer(row)">删除</el-button>
											</template>

											<template v-else-if="row.state === '2' || row.state === 2">
												<!-- 已提交状态：显示详情、审核、驳回按钮 -->
												<el-button type="text" size="small"
													@click="handleViewTransfer(row)">详情</el-button>
												<el-button type="text" size="small"
													@click="handleAuditTransfer(row)">审核</el-button>
												<el-button type="text" size="small"
													@click="handleRejectTransfer(row)">驳回</el-button>
											</template>

											<template v-else-if="row.state === '4' || row.state === 4">
												<!-- 已审核状态：显示详情、过单、驳回按钮 -->
												<el-button type="text" size="small"
													@click="handleViewTransfer(row)">详情</el-button>
												<el-button type="text" size="small"
													@click="handlePassTransfer(row)">过单</el-button>
												<el-button type="text" size="small"
													@click="handleRejectTransfer(row)">驳回</el-button>
											</template>

											<template v-else-if="row.state === '5' || row.state === 5">
												<!-- 已过单状态：显示详情、冲销按钮 -->
												<el-button type="text" size="small"
													@click="handleViewTransfer(row)">详情</el-button>
												<el-button type="text" size="small"
													@click="handleReverseTransfer(row)">冲销</el-button>
											</template>

											<template v-else>
												<!-- 其他状态：只显示详情按钮 -->
												<el-button type="text" size="small"
													@click="handleViewTransfer(row)">详情</el-button>
												<el-button v-if="row.state === '6' || row.state === 6" type="text"
													size="small" disabled>
													已冲销
												</el-button>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>

					<div class="pagination-container">
						<span class="total-text">共{{ transferPagination.total }}条</span>
						<el-pagination v-model:current-page="transferPagination.currentPage"
							v-model:page-size="transferPagination.pageSize" :page-sizes="[10, 20, 50, 100]"
							layout="sizes, prev, pager, next" :total="transferPagination.total"
							@size-change="handleTransferSizeChange" @current-change="handleTransferCurrentChange" />
					</div>
				</el-card>
			</div>
		</div>

		<!-- 打开统一出库单模态框 -->
		<el-dialog :visible.sync="dialogVisible" :title="safeGetTitle()" width="80%" top="5vh" class="transfer-dialog"
			:before-close="handleSimpleClose" :fullscreen="true" @keydown.native="handleDialogKeydown">

			<div class="dialog-body">
				<!-- 出库单信息 -->
				<div class="form-section">
					<div class="section-title">出库单信息</div>
					<div class="form-layout-optimized" v-if="dialogMode === 'add' || dialogMode === 'edit'">
						<div class="form-row">
							<div class="form-item">
								<label class="form-label">出库单号</label>
								<el-input v-model="transferForm.docNum" placeholder="系统自动生成" disabled class="form-input"
									size="mini"></el-input>
							</div>
							<div class="form-item">
								<label class="form-label">出库药库</label>
								<el-select v-model="transferForm.phayId" placeholder="请选择出库药库" class="warehouse-select"
									size="mini" @change="handleOutWarehouseChange">
									<el-option v-for="item in warehouseOptions" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</div>
							<!-- 新增：供货单位 -->
							<div class="form-item">
								<label class="form-label">供货单位</label>
								<el-select v-model="transferForm.supplyCandidateId" placeholder="请选择供货单位"
									class="supplier-select" size="mini" filterable clearable :disabled="isReadonlyMode">
									<el-option v-for="item in supplierOptions" :key="item.id" :label="item.supplierName"
										:value="item.id"></el-option>
								</el-select>
							</div>
							<!-- 新增：出库方式 -->
							<div class="form-item">
								<label class="form-label">出库方式</label>
								<el-select v-model="transferForm.retnTypeId" placeholder="请选择出库方式"
									class="retn-type-select" size="mini" clearable :disabled="isReadonlyMode"
									@change="handleRetnTypeChange">
									<el-option v-for="item in retnTypeOptions" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</div>
							<div class="form-item">
								<label class="form-label">操作人</label>
								<el-input v-model="transferForm.createName" placeholder="操作人" disabled
									class="form-input" size="mini"></el-input>
							</div>
							<div class="form-item">
								<label class="form-label">业务日期</label>
								<el-date-picker v-model="transferForm.busDate" type="date" placeholder="选择业务日期"
									class="form-datepicker" value-format="YYYY-MM-DD" size="mini"
									:disabled="isReadonlyMode"></el-date-picker>
							</div>
						</div>
					</div>

					<!-- 只读模式显示出库单信息 -->
					<div class="readonly-info" v-if="dialogMode !== 'add' && dialogMode !== 'edit'">
						<div class="info-row">
							<div class="info-item">
								<label class="info-label">出库单号：</label>
								<span class="info-value">{{ currentTransferRow.docNum }}</span>
							</div>
							<div class="info-item">
								<label class="info-label">业务日期：</label>
								<span class="info-value">{{ formatDate(currentTransferRow.busDate) }}</span>
							</div>
							<div class="info-item">
								<label class="info-label">操作人：</label>
								<span class="info-value">{{ currentTransferRow.createName }}</span>
							</div>
							<!-- 新增：只读模式显示供货单位 -->
							<div class="info-item" v-if="currentTransferRow.supplierName">
								<label class="info-label">供货单位：</label>
								<span class="info-value">{{ currentTransferRow.supplierName }}</span>
							</div>
						</div>
					</div>
				</div>

				<!-- 出库药品列表 -->
				<div class="form-section">
					<div class="section-title">
						<span>出库药品列表</span>
						<div class="row-info">
							<el-checkbox v-model="enableEnterAdd" size="mini" @change="handleEnterAddChange">
								回车添加出库药品
							</el-checkbox>
							<el-tag :type="getTransferModeTagType" size="medium" style="margin-left: auto;">
								{{ getTransferModeText }}
							</el-tag>
						</div>
					</div>
					<div class="table-scroll-wrapper">
						<div class="table-scroll-container">
							<el-table ref="goodsTable" :data="transferGoods" border style="width: 100%;"
								v-loading="goodsListLoading" :max-height="500">
								<el-table-column label="操作" width="80" align="center" fixed="left">
									<template #header>
										<el-tooltip content="添加一行" placement="top">
											<el-button type="primary" icon="el-icon-plus" size="mini" circle
												@click="addSingleRow"></el-button>
										</el-tooltip>
									</template>
									<template #default="scope">
										<div class="row-action-container">
											<span class="row-number">{{ scope.$index + 1 }}</span>
										</div>
									</template>
								</el-table-column>

								<!-- 药品名称列 - 修改为下拉选择框 -->
								<el-table-column prop="drugName" label="药品名称" width="288" show-overflow-tooltip>
									<template #default="scope">
										<el-select v-model="scope.row.id" placeholder="请选择药品" filterable clearable
											size="mini" style="width: 100%"
											@change="handleDrugSelectChange(scope.row, $event)"
											:disabled="isReadonlyMode">
											<el-option-group v-for="group in drugOptions" :key="group.label">
												<!-- 药品名称标题（不可选择） -->
												<el-option disabled class="drug-title-option" :value="null">
													<span
														style="font-weight: bold; color: #409EFF;">{{ group.label }}</span>
												</el-option>
												<!-- 批次号选项 -->
												<el-option v-for="item in group.options" :key="item.id"
													:label="getBatchOptionLabel(item)" :value="item.id">
													<!-- 使用item.id作为value -->
													<div class="batch-option-content">
														<div class="batch-main-info" style="font-size:12px;">
															<span
																class="batch-label">批次号：{{ item.manuLotnum || '无批次' }}</span>
															<span style="margin-left:8px;" class="batch-spec"
																v-if="item.prodentpName">厂家：{{ item.prodentpName }}</span>
														</div>
													</div>
												</el-option>
											</el-option-group>
										</el-select>
									</template>
								</el-table-column>

								<!-- 申请出库数量列 -->
								<el-table-column prop="allotNum" label="申请出库数量" width="180" align="center">
									<template #default="scope">
										<div class="quantity-edit-cell">
											<!-- 编辑模式显示输入框 -->
											<template
												v-if="scope.row.editing || dialogMode === 'add' || dialogMode === 'edit'">
												<div class="edit-input-group">
													<el-input-number v-model.number="scope.row.apllyAmt"
														placeholder="请输入数量" size="mini" :min="1" :precision="0"
														@blur="handleQuantityBlur(scope.row)"
														@input="handleQuantityInput(scope.row)"
														:class="getMainTableInputClass(scope.row)"
														style="width: 120px; margin-right: 8px;">
													</el-input-number>
													<!-- 当前单位显示在输入框右侧 -->
													<span class="quantity-unit">{{ scope.row.currentUnit || '' }}</span>
												</div>
												<!-- 包装数量提示 -->
												<div v-if="scope.row.pacCnt > 1" class="package-hint">
													包装数量：{{ scope.row.pacCnt }}
												</div>
												<div v-if="scope.row.validationError" class="validation-error">
													{{ scope.row.validationError }}
												</div>
											</template>
											<!-- 非编辑模式只显示 -->
											<template v-else>
												<span class="quantity-display">{{ scope.row.apllyAmt || 0 }}</span>
												<span class="quantity-unit">{{ scope.row.currentUnit || '' }}</span>
												<div v-if="scope.row.pacCnt > 1" class="package-hint">
													包装数量：{{ scope.row.pacCnt }}
												</div>
											</template>
										</div>
									</template>
								</el-table-column>

								<!-- 库存类型列 -->
								<el-table-column prop="purcType" label="库存类型" width="120" align="center">
									<template #default="scope">
										<el-select v-if="(dialogMode === 'add' || dialogMode === 'edit')"
											v-model="scope.row.purcType" size="mini"
											@change="handlePurcTypeChange(scope.row)" style="width: 100%"
											:disabled="scope.row.validating || isReadonlyMode">
											<el-option label="最小单位" :value="1" />
											<el-option label="包装单位" :value="2" />
										</el-select>
										<span v-else>{{ scope.row.purcType === 1 ? '最小单位' : '包装单位' }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="manuLotnum" label="批次号" width="120" align="center"
									show-overflow-tooltip>
									<template #default="{ row }">
										<span>{{ row.manuLotnum || '--' }}</span>
									</template>
								</el-table-column>
								<el-table-column label="当前可用库存" width="150" align="center">
									<template #default="{ row }">
										<el-tooltip :content="getStockDisplayText(row)" placement="top">
											<span>{{ getStockDisplayText(row) }}</span>
										</el-tooltip>
									</template>
								</el-table-column>

								<el-table-column prop="drugSpec" label="规格描述" width="120"
									show-overflow-tooltip></el-table-column>

								<el-table-column prop="purcPric" label="成本单价" width="100" align="right">
									<template #default="{ row }">
										¥{{ Number(row.purcPric || 0).toFixed(2) }}
									</template>
								</el-table-column>

								<el-table-column prop="purcAmt" label="成本金额" width="100" align="right">
									<template #default="{ row }">
										¥{{ Number(row.purcAmt || 0).toFixed(2) }}
									</template>
								</el-table-column>

								<el-table-column prop="salePric" label="零售单价" width="100" align="right">
									<template #default="{ row }">
										¥{{ Number(row.salePric || 0).toFixed(2) }}
									</template>
								</el-table-column>

								<el-table-column prop="saleAmt" label="零售金额" width="100" align="right">
									<template #default="{ row }">
										¥{{ Number(row.saleAmt || 0).toFixed(2) }}
									</template>
								</el-table-column>

								<el-table-column prop="manuDate" label="生产期" width="120" show-overflow-tooltip>
									<template #default="{ row }">
										{{ row.manuDate || '--' }}
									</template>
								</el-table-column>

								<el-table-column prop="expyDate" label="有效期" width="120" show-overflow-tooltip>
									<template #default="{ row }">
										{{ row.expyDate || '--' }}
									</template>
								</el-table-column>

								<el-table-column prop="supplierName" label="供货单位" width="150" align="center"
									show-overflow-tooltip>
									<template #default="{ row }">
										<el-tooltip :content="row.supplierName" placement="top">
											<span>{{ row.supplierName }}</span>
										</el-tooltip>
									</template>
								</el-table-column>

								<!-- 生产厂家列 - 修复显示并固定在右侧 -->
								<el-table-column prop="prodentpName" label="生产厂家" width="140" align="center"
									show-overflow-tooltip fixed="right">
									<template #default="{ row }">
										<el-tooltip :content="getManufacturerDisplayText(row)" placement="top">
											<span>{{ getManufacturerDisplayText(row) }}</span>
										</el-tooltip>
									</template>
								</el-table-column>

								<el-table-column label="操作" width="120" align="center" fixed="right">
									<template #default="scope">
										<div class="row-operations">
											<el-button type="text" size="mini" class="delete-btn"
												@click="handleRemoveGoods(scope.row, scope.$index)"
												:disabled="isReadonlyMode">
												删除
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="feets">
						<!-- 金额合计 -->
						<div class="total-amount" v-if="dialogMode === 'add' || dialogMode === 'edit'">
							<span>成本合计：</span>
							<el-input v-model="cbValue" style="width: 120px;" size="mini" disabled></el-input>
							<span style="margin-left: 12px;">零售合计：</span>
							<el-input v-model="lsValue" style="width: 120px;" size="mini" disabled></el-input>
						</div>
						<div class="action-buttons">
							<el-button @click="dialogVisible = false" size="mini">关闭</el-button>
							<!-- 提交按钮 - 添加状态控制和提示 -->
							<el-tooltip :content="getSubmitButtonTooltip()" placement="top" :disabled="isSubmitEnabled">
								<div>
									<el-button v-if="dialogMode === 'add'" type="primary" @click="submitTransfer"
										size="mini" :disabled="!isSubmitEnabled || isEditingRow">提交出库单</el-button>
									<el-button v-if="dialogMode === 'edit'" type="primary" @click="submitEditTransfer"
										size="mini" :disabled="!isSubmitEnabled || isEditingRow">修改出库单</el-button>
								</div>
							</el-tooltip>
							<el-button v-if="dialogMode === 'submit'" type="primary" @click="handleStateChange"
								size="mini">提交审核</el-button>
							<el-button v-if="dialogMode === 'aduit'" type="primary" @click="handleStateChange"
								size="mini">确认审核</el-button>
							<el-button v-if="dialogMode === 'pass'" type="primary" @click="handleStateChange"
								size="mini">确认过单</el-button>
							<el-button v-if="dialogMode === 'resave'" type="primary" @click="handleStateChange"
								size="mini">确认冲销</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import {
		ZYdugRetnPage,
		selectDropDownList,
		ZYFAddReturn,
		ZYFtoExamine,
		ZYFgetDrugRetnList,
		ZYFdugRetnWays,
		ZYFdugRetnJoin,
		ZYFdeleteRetn,
		ZYFselectDrug,
		ZYFEditReturn
	} from "@/api/systemCatalogue/Western.js";


	export default {
		name: 'ZyReturn',
		props: {
			outWarehouse: {
				type: [String, Number],
				default: 4
			},
			state: {
				type: [String, Number],
				default: ''
			},
			startDate: {
				type: String,
				default: ''
			},
			endDate: {
				type: String,
				default: ''
			},
			documentNo: {
				type: String,
				default: ''
			}
		},
		data() {
			const currentDate = new Date();
			const formattedDate = currentDate.toISOString().split('T')[0];

			// 从本地存储获取用户信息
			let userInfo = {};
			try {
				userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
			} catch (error) {
				console.error('解析用户信息失败:', error);
			}

			return {
				// 新增：回车添加药品功能
				enableEnterAdd: true, // 默认勾选回车添加功能
				isEnterKeyEnabled: true, // 新增：控制回车键是否启用
				// 药品选项数据
				drugOptions: [], // 药品下拉选项
				// 出库方式选项
				retnTypeOptions: [], // 出库方式下拉选项
				// 原有数据保持不变
				transferFilter: {
					state: '',
					dateRange: []
				},
				transferPagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				transferTableData: [],
				transferTableLoading: false,
				selectedTransferRows: [],

				chart: null,
				totalData: {
					transferCount: 0,
					medicineCount: 0,
					totalAmount: '0.00'
				},
				// 编辑状态控制
				isEditingRow: false,
				currentEditingIndex: -1,
				editingRowBackup: null,
				// 模态框相关数据
				dialogVisible: false,
				dialogMode: 'add',
				currentTransferRow: null,

				// 表单数据
				transferForm: {
					phayId: 4,
					busDate: formattedDate,
					docNum: this.generateDocNum(1),
					createName: userInfo.staffName || 'admin',
					supplyCandidateId: null,
					retnTypeId: 1, // 修改：默认值为1（采购退库）
					retnTypeName: '采购退库', // 修改：默认名称
					remarks: ''
				},

				// 加载状态
				goodsListLoading: false,

				// 药品相关数据
				searchQuery: '',
				currentPage: 1,
				pageSize: 30,
				totalItems: 0,
				transferGoods: [], // 出库药品列表
				isTableLoading: false,
				lastLoadTime: 0,
				loadDebounce: 500,

				// 药库选项
				warehouseOptions: [{
					value: 4,
					label: '中药房'
				}, ],

				// 金额合计
				cbValue: '0.00',
				lsValue: '0.00',

				// 提交按钮禁用状态
				isSubmitDisabled: true, // 默认禁用

				// 新增：供货单位选项
				supplierOptions: [], // 供货单位下拉选项
				// 防抖定时器
				debounceTimer: null,
				debounceTimers: {},
				validatingRows: new Set(),
			};
		},
		computed: {
			// 新增：只读模式判断
			isReadonlyMode() {
				return ['view', 'submit', 'aduit', 'pass', 'resave'].includes(this.dialogMode);
			},

			// 新增：提交按钮启用状态计算
			isSubmitEnabled() {
				// 检查是否有数据
				if (this.transferGoods.length === 0) {
					return false;
				}

				// 检查每行数据的完整性
				const validRows = this.transferGoods.filter(row => {
					return this.isRowValid(row);
				});

				// 所有行都有效才启用提交按钮
				return validRows.length === this.transferGoods.length && validRows.length > 0;
			},

			// 其他计算属性保持不变
			isAddButtonDisabled() {
				return this.transferGoods.length === 0 || this.hasValidationErrors;
			},

			hasValidationErrors() {
				return this.transferGoods.some(item => item.validated === false);
			},

			getTransferModeText() {
				// 根据出库方式显示对应的文本
				if (this.transferForm.retnTypeId) {
					const selectedOption = this.retnTypeOptions.find(item => item.id === this.transferForm.retnTypeId);
					return selectedOption ? selectedOption.name : '未知出库模式';
				}
				return '未知出库模式';
			},

			getTransferModeTagType() {
				// 根据出库方式设置标签类型
				if (this.transferForm.retnTypeId === 1) {
					return 'success'; // 采购退库用success类型
				} else if (this.transferForm.retnTypeId === 2) {
					return 'warning'; // 其他类型用warning
				} else {
					return 'info'; // 默认用info
				}
			},

			// 直接使用 transferGoods 作为表格数据
			processedTransferGoods() {
				return this.transferGoods;
			}
		},
		watch: {
			dialogVisible: {
				handler(newVal) {
					if (newVal) {
						// 对话框打开时，如果启用回车添加且不是只读模式，绑定事件
						if (this.enableEnterAdd && !this.isReadonlyMode) {
							this.$nextTick(() => {
								this.bindEnterKey();
							});
						}
					} else {
						// 对话框关闭时解绑事件
						this.unbindEnterKey();
					}
				},
				immediate: true
			},

			// 监听只读模式变化
			isReadonlyMode: {
				handler(newVal) {
					if (this.dialogVisible) {
						if (newVal) {
							// 进入只读模式时解绑回车键
							this.unbindEnterKey();
						} else if (this.enableEnterAdd) {
							// 退出只读模式且启用回车添加时绑定事件
							this.bindEnterKey();
						}
					}
				}
			},

			// 监听回车添加功能开关
			enableEnterAdd: {
				handler(newVal) {
					if (this.dialogVisible) {
						if (newVal && !this.isReadonlyMode) {
							// 开启回车添加功能且不是只读模式时绑定事件
							this.bindEnterKey();
						} else {
							// 关闭回车添加功能时解绑事件
							this.unbindEnterKey();
						}
					}
				}
			}
		},

		// 监听只读模式变化
		isReadonlyMode: {
			handler(newVal) {
				if (this.dialogVisible) {
					if (newVal) {
						// 进入只读模式时解绑回车键
						this.unbindEnterKey();
					} else if (this.enableEnterAdd) {
						// 退出只读模式且启用回车添加时绑定事件
						this.bindEnterKey();
					}
				}
			}
		},

		// 监听出库药品列表变化，更新提交按钮状态
		transferGoods: {
			handler(newVal) {
				this.updateSubmitButtonState();
			},
			deep: true
		},

		// 监听出库药库变化，重新生成出库单号
		'transferForm.outWarehouse': {
			handler(newVal) {
				if (this.dialogVisible) {
					this.transferForm.docNum = this.generateDocNum(newVal);
					this.loadDrugOptions();
				}
			}
		},
		// 其他watch保持不变
		startDate: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.debouncedLoadData();
				}
			}
		},
		endDate: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.debouncedLoadData();
				}
			}
		},
		state: {
			immediate: true,
			handler(newVal) {
				this.debouncedLoadData();
			}
		},
		documentNo: {
			immediate: true,
			handler(newVal) {
				this.debouncedLoadData();
			}
		},
		mounted() {
			// 初始化时检查提交按钮状态
			this.updateSubmitButtonState();
			// 初始化时加载供货单位选项
			this.loadSupplierOptions();
			this.loadRetnTypeOptions(); // 新增：加载出库方式选项
		},
		beforeUnmount() {
			if (this.chart) {
				this.chart.dispose();
			}
			// 组件销毁时确保移除事件监听
			this.unbindEnterKey();
		},
		methods: {
			/* 工具类 */
			// 新增：绑定回车键事件监听
			bindEnterKey() {
				// 检查是否已经绑定过事件
				if (this.isEnterKeyBound) {
					console.log('回车键事件已经绑定，跳过重复绑定');
					return;
				}

				document.addEventListener('keydown', this.handleGlobalKeydown, true); // 使用捕获阶段
				this.isEnterKeyBound = true;
				console.log('回车键事件监听已绑定');
			},
			/* 新增：加载出库方式选项 */
			async loadRetnTypeOptions() {
				try {
					const response = await ZYFdugRetnWays({
						// 根据实际接口需求传递参数
						// 如果没有参数要求，可以传递空对象或根据实际情况调整
					});

					if (response.code === 200) {
						this.retnTypeOptions = response.data || [];
						console.log('出库方式选项加载成功:', this.retnTypeOptions);
					} else {
						console.error('获取出库方式列表失败:', response.message);
						this.$message.error('获取出库方式列表失败');
					}
				} catch (error) {
					console.error('加载出库方式选项失败:', error);
					this.$message.error('加载出库方式选项失败');
				}
			},

			/* 新增：出库方式变化处理 */
			handleRetnTypeChange(value) {
				if (value) {
					const selectedOption = this.retnTypeOptions.find(item => item.id === value);
					this.transferForm.retnTypeName = selectedOption ? selectedOption.name : '';
					console.log('出库方式已选择:', this.transferForm.retnTypeName, 'ID:', value);

					// 触发计算属性更新
					this.$forceUpdate();
				} else {
					this.transferForm.retnTypeName = '';
					console.log('出库方式已清空');
				}
			},
			/* 新增：加载供货单位选项 */
			async loadSupplierOptions() {
				try {
					const response = await selectDropDownList();

					if (response.code === 200) {
						this.supplierOptions = response.data.content || [];
						console.log('供货单位选项加载成功:', this.supplierOptions);
					} else {
						console.error('获取供货单位列表失败:', response.message);
						this.$message.error('获取供货单位列表失败');
					}
				} catch (error) {
					console.error('加载供货单位选项失败:', error);
					this.$message.error('加载供货单位选项失败');
				}
			},
			// 新增：解绑回车键事件监听
			unbindEnterKey() {
				if (this.isEnterKeyBound) {
					document.removeEventListener('keydown', this.handleGlobalKeydown, true);
					this.isEnterKeyBound = false;
					console.log('回车键事件监听已解绑');
				}

				// 清理状态
				this.cleanupEnterKeyState();
			},

			handleGlobalKeydown(event) {
				// 只有在对话框打开且启用回车添加功能时处理
				if (!this.dialogVisible || !this.enableEnterAdd || this.isReadonlyMode) {
					return;
				}

				// 检查是否按下了回车键
				if (event.key === 'Enter') {
					// 检查是否在输入元素中，避免冲突
					const target = event.target;
					const isInputElement =
						target.tagName === 'INPUT' ||
						target.tagName === 'TEXTAREA' ||
						target.tagName === 'SELECT' ||
						target.closest('.el-select') ||
						target.closest('.el-input-number') ||
						target.closest('.el-date-editor');

					if (isInputElement) {
						return; // 在输入元素中，不处理回车键
					}

					// 防止默认行为
					event.preventDefault();
					event.stopPropagation(); // 阻止事件冒泡

					// 添加防抖和重复触发检查
					this.debouncedExecuteAddSingleRow();
				}
			},

			// 新增：防抖执行添加单行方法
			debouncedExecuteAddSingleRow() {
				// 清除现有的防抖定时器
				if (this.enterKeyDebounceTimer) {
					clearTimeout(this.enterKeyDebounceTimer);
				}

				// 检查是否正在处理回车键（防止重复触发）
				if (this.isProcessingEnterKey) {
					console.log('回车键正在处理中，跳过重复触发');
					return;
				}

				// 设置防抖定时器
				this.enterKeyDebounceTimer = setTimeout(() => {
					this.executeAddSingleRow();
				}, 100); // 100毫秒防抖
			},

			// 修改：执行添加单行的方法
			async executeAddSingleRow() {
				// 设置处理状态，防止重复执行
				if (this.isProcessingEnterKey) {
					console.log('回车键正在处理中，跳过执行');
					return;
				}

				if (!this.isEnterKeyEnabled) {
					console.log('回车添加功能被禁用');
					return;
				}

				// 设置处理状态
				this.isProcessingEnterKey = true;

				try {
					console.log('执行回车添加行操作');
					await this.addSingleRow();

					// 添加视觉反馈
					this.showEnterAddFeedback();

				} catch (error) {
					console.error('回车添加行失败:', error);
				} finally {
					// 重置处理状态，但添加延迟防止快速重复触发
					setTimeout(() => {
						this.isProcessingEnterKey = false;
					}, 500); // 500毫秒内不允许重复触发
				}
			},

			// 新增：显示回车添加的视觉反馈
			showEnterAddFeedback() {
				// 清除现有的提示定时器
				if (this.feedbackTimer) {
					clearTimeout(this.feedbackTimer);
				}

				// 设置防重复提示
				if (this.isShowingFeedback) {
					console.log('反馈提示正在显示中，跳过重复提示');
					return;
				}

				this.isShowingFeedback = true;

				// 可以添加一些视觉反馈，比如闪烁效果
				const lastRow = this.transferGoods[this.transferGoods.length - 1];
				if (lastRow && this.$refs.goodsTable) {
					// 暂时高亮新添加的行
					this.$refs.goodsTable.setCurrentRow(lastRow);

					// 1秒后取消高亮
					setTimeout(() => {
						this.$refs.goodsTable.setCurrentRow();
					}, 1000);
				}

				// 添加提示信息 - 使用轻量级提示
				this.$message({
					message: '已通过回车键添加新行',
					type: 'success',
					duration: 1500, // 缩短显示时间
					showClose: false
				});

				// 1.5秒后重置反馈状态
				this.feedbackTimer = setTimeout(() => {
					this.isShowingFeedback = false;
				}, 1500);
			},

			// 新增：检查行数据是否有效
			isRowValid(row) {
				// 检查必填字段
				const requiredFields = [
					'drugId', // 药品ID
					'drugName', // 药品名称
					'apllyAmt', // 申请出库数量
					'purcType', // 库存类型
					'prodentpName', // 生产厂家
					'manuLotnum' // 批次号
				];

				for (const field of requiredFields) {
					if (!row[field] || (typeof row[field] === 'string' && row[field].trim() === '')) {
						return false;
					}
				}

				// 检查数量有效性
				if (!row.apllyAmt || row.apllyAmt <= 0) {
					return false;
				}

				return true;
			},

			// 新增：获取提交按钮的提示信息
			getSubmitButtonTooltip() {
				if (this.transferGoods.length === 0) {
					return '请至少添加一条出库药品';
				}

				// 检查无效的行
				const invalidRows = this.transferGoods.filter(row => !this.isRowValid(row));
				if (invalidRows.length > 0) {
					const invalidRowNumbers = invalidRows.map((row, index) => {
						const rowIndex = this.transferGoods.indexOf(row) + 1;
						return `第${rowIndex}行`;
					}).join('、');

					return `以下行数据不完整：${invalidRowNumbers}。请检查药品名称、数量、生产厂家、批次号等必填项`;
				}

				return '所有数据完整，可以提交';
			},

			// 新增：更新提交按钮状态
			updateSubmitButtonState() {
				this.$nextTick(() => {
					this.isSubmitDisabled = !this.isSubmitEnabled;
				});
			},

			// 新增：获取生产厂家显示文本
			getManufacturerDisplayText(row) {
				if (row.prodentpName) {
					return row.prodentpName;
				}

				// 如果生产厂家为空，尝试从药品选项中获取
				if (row.drugId) {
					const drug = this.findDrugById(row.drugId);
					if (drug && drug.manufacturer) {
						return drug.manufacturer;
					}
				}

				return '--';
			},

			// 修改：删除药品行方法
			handleRemoveGoods(row, index) {
				// 如果行中没有药品名称，直接删除不提示
				if (!row.drugId && !row.drugName) {
					this.transferGoods.splice(index, 1);
					this.calculateTotals();
					this.updateSubmitButtonState();
					return;
				}

				// 有药品数据的行需要确认删除
				this.$confirm('确定要删除这个药品吗？', '删除确认', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.transferGoods.splice(index, 1);
					this.calculateTotals();
					this.updateSubmitButtonState();
					this.$message.success('删除成功');
				}).catch(() => {
					// 用户取消删除
				});
			},

			// 修改：库存类型变化处理 - 添加数量重新计算
			async handlePurcTypeChange(row) {
				if (!row.drugId) {
					this.$message.warning('请先选择药品');
					return;
				}

				// 保存旧类型用于数量转换计算
				const oldType = row.oldPurcType || row.purcType;
				const newType = row.purcType;

				// 如果新旧类型相同，不需要处理
				if (oldType === newType) {
					this.updateCurrentUnitDisplay(row);
					this.updateSubmitButtonState();
					return;
				}

				// 更新当前单位显示
				this.updateCurrentUnitDisplay(row);

				// 如果有数量，重新计算数量
				if (row.apllyAmt && row.apllyAmt > 0) {
					await this.recalculateApplyAmount(row, oldType, newType);
				}

				// 保存当前类型作为下次的旧类型
				row.oldPurcType = newType;

				// 重新验证库存
				if (row.apllyAmt && row.apllyAmt > 0) {
					await this.validateRowStock(row);
				}

				this.updateSubmitButtonState();
			},

			// 新增：重新计算申请出库数量
			async recalculateApplyAmount(row, oldType, newType) {
				if (!row.apllyAmt || row.apllyAmt <= 0) {
					return;
				}

				const pacCnt = row.pacCnt || 1;
				const oldAmount = row.apllyAmt;
				let newAmount = oldAmount;
				let calculationInfo = '';

				try {
					// 从包装单位切换到最小单位
					if (oldType === 2 && newType === 1) {
						newAmount = oldAmount * pacCnt;
						calculationInfo = `包装单位转换为最小单位：${oldAmount} × ${pacCnt} = ${newAmount}`;
					}
					// 从最小单位切换到包装单位
					else if (oldType === 1 && newType === 2) {
						if (oldAmount % pacCnt !== 0) {
							// 如果有余数，向上取整
							newAmount = Math.ceil(oldAmount / pacCnt);
							calculationInfo =
								`最小单位转换为包装单位：${oldAmount} ÷ ${pacCnt} = ${(oldAmount / pacCnt).toFixed(2)}，已向上取整为 ${newAmount}`;
							this.$message.warning(`数量${oldAmount}无法被包装数量${pacCnt}整除，已向上取整为${newAmount}`);
						} else {
							newAmount = oldAmount / pacCnt;
							calculationInfo = `最小单位转换为包装单位：${oldAmount} ÷ ${pacCnt} = ${newAmount}`;
						}
					}

					// 更新数量
					row.apllyAmt = newAmount;

					// 显示计算信息
					console.log('数量转换计算：', {
						旧类型: oldType === 1 ? '最小单位' : '包装单位',
						新类型: newType === 1 ? '最小单位' : '包装单位',
						旧数量: oldAmount,
						新数量: newAmount,
						包装数量: pacCnt,
						计算说明: calculationInfo
					});

					this.$message.info(`当前数量：${oldAmount} → ${newAmount}`);

					// 重新计算金额
					this.calculateRowAmount(row);
					this.calculateTotals();

				} catch (error) {
					console.error('重新计算数量失败:', error);
					this.$message.error('数量计算失败');
				}
			},

			// 修改：更新当前单位显示
			updateCurrentUnitDisplay(row) {
				if (row.purcType === 1) {
					row.currentUnit = row.dosUnt || '最小单位';
				} else {
					row.currentUnit = row.pacUnt || '包装单位';
				}
			},

			// 修改：添加单行方法 - 正确初始化所有字段
			addSingleRow() {
				const newRow = {
					id: null,
					drugId: null,
					drugName: '',
					drugSpec: '',
					apllyAmt: null,
					purcType: 2,
					purcPric: 0,
					salePric: 0,
					purcAmt: '0.00',
					saleAmt: '0.00',
					validated: false,
					editing: false,
					validating: false,
					validationError: '',
					currentUnit: '包装单位',
					pacCnt: 1, // 默认包装数量
					dosUnt: '最小单位',
					pacUnt: '包装单位',

					// 关键修改：初始化生产厂家、批次号、有效期、生产期、供货单位
					prodentpName: '',
					manuLotnum: '',
					expyDate: '',
					manuDate: '',
					supplierName: '',

					// 新增：记录旧类型用于数量转换
					oldPurcType: 2, // 默认设置为包装单位

					isEmpty: false
				};

				this.transferGoods.push(newRow);
				this.updateSubmitButtonState();

				// 滚动到最后一行
				this.$nextTick(() => {
					const tableWrapper = this.$refs.goodsTable?.$el?.querySelector('.el-table__body-wrapper');
					if (tableWrapper) {
						tableWrapper.scrollTop = tableWrapper.scrollHeight;
					}
				});

				console.log('新增行成功，当前行数:', this.transferGoods.length);
			},

			// 修改：处理药品选择变化 - 正确设置所有字段
			async handleDrugSelectChange(row, selectedId) {
				if (!selectedId) {
					// 清空选择，重置行数据
					this.resetRowData(row);
					this.updateSubmitButtonState();
					return;
				}

				// 关键修改：通过selectedId（批次号的id）查找对应的药品信息
				const selectedDrug = this.findDrugById(selectedId);
				if (!selectedDrug) {
					console.error('未找到对应药品信息，selectedId:', selectedId);
					this.$message.error('未找到对应的药品信息');
					this.updateSubmitButtonState();
					return;
				}

				try {
					console.log('选择的药品信息:', selectedDrug);

					// 关键修改：使用批次号的id作为主id，并设置所有相关字段
					Object.assign(row, {
						id: selectedDrug.id, // 批次号的id
						drugId: selectedDrug.drugId, // 药品ID
						drugName: selectedDrug.drugName || '',
						drugSpec: selectedDrug.drugSpec || '',
						pacCnt: selectedDrug.pacCnt || 1, // 确保包装数量正确设置
						dosUnt: selectedDrug.dosUnt || '最小单位',
						pacUnt: selectedDrug.pacUnt || '包装单位',

						// 关键修改：设置生产厂家和批次号
						prodentpName: selectedDrug.prodentpName || selectedDrug.manufacturer || '',
						manuLotnum: selectedDrug.manuLotnum || '',

						// 关键修改：设置有效期、生产期、供货单位
						expyDate: selectedDrug.expyDate || selectedDrug.validityDate || selectedDrug
							.validUntil || '',
						manuDate: selectedDrug.manuDate || selectedDrug.productionDate || selectedDrug
							.manufactureDate || '',
						supplierName: selectedDrug.supplierName || selectedDrug.supplier || selectedDrug
							.provider || '',

						// 设置其他可能相关的字段
						manuDate: selectedDrug.manuDate || '',
						expyDate: selectedDrug.expyDate || '',

						// 重置旧类型记录
						oldPurcType: 2 // 默认设置为包装单位
					});

					// 设置默认值
					row.apllyAmt = 1;
					row.purcType = 2;
					row.currentUnit = row.pacUnt || '包装单位';

					// 验证库存 - 使用正确的id
					const validateResult = await this.validateGoodsStock(row, 2, 1);

					if (validateResult.code === 200) {
						row.validated = true;
						this.updateRowData(row, validateResult.data);
						this.calculateRowAmount(row);
						this.calculateTotals();
						this.$message.success(`药品 ${row.drugName} 添加成功`);

						// 关键修改：验证成功后再次确保字段正确设置
						console.log('设置后的行数据:', {
							药品名称: row.drugName,
							批次号: row.manuLotnum,
							包装数量: row.pacCnt,
							库存类型: row.purcType === 1 ? '最小单位' : '包装单位',
							申请数量: row.apllyAmt
						});
					} else {
						await this.handlePackageUnitInsufficient(row, selectedDrug, validateResult);
					}

					this.updateSubmitButtonState();

				} catch (error) {
					console.error('选择药品失败:', error, 'selectedId:', selectedId);
					this.$message.error('选择药品失败');
					this.updateSubmitButtonState();
				}
			},

			// 修改：重置行数据 - 清空所有字段
			resetRowData(row) {
				Object.assign(row, {
					id: null,
					drugId: null,
					drugName: '',
					drugSpec: '',
					apllyAmt: null,
					purcType: 2,
					purcPric: 0,
					salePric: 0,
					purcAmt: '0.00',
					saleAmt: '0.00',
					validated: false,
					validationError: '',
					currentUnit: '包装单位',

					// 关键修改：清空生产厂家、批次号、有效期、生产期、供货单位
					prodentpName: '',
					manuLotnum: '',
					expyDate: '',
					manuDate: '',
					supplierName: ''
				});
				this.updateSubmitButtonState();
			},

			// 其他现有方法保持不变...
			getTransferStatusText(state) {
				const stateStr = String(state);
				const textMap = {
					'0': '草稿',
					'2': '已提交',
					'4': '已审核',
					'5': '已过单',
					'6': '已冲销'
				};
				return textMap[stateStr] || '未知状态';
			},

			// 日期格式化
			formatDate(dateString) {
				if (!dateString) return '--';
				const date = new Date(dateString);
				return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
			},

			formatDateTime(dateString) {
				if (!dateString) return '--';
				const date = new Date(dateString);
				return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
			},

			// 防抖相关
			debouncedLoadData() {
				if (this.debounceTimer) {
					clearTimeout(this.debounceTimer);
				}

				this.debounceTimer = setTimeout(() => {
					this.loadTransferData();
				}, 300);
			},

			// 刷新事件
			handleRefresh() {
				this.loadTransferData();
			},

			// 出库单草稿删除
			async handleBatchDelete() {
				if (this.selectedTransferRows.length === 0) {
					this.$message.warning('请选择要删除的出库单');
					return;
				}

				try {
					this.$confirm('确定要删除选中的出库单吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						this.$message.success('删除成功');
						this.loadTransferData();
						this.selectedTransferRows = [];
					});
				} catch (error) {
					console.error('批量删除出库单失败:', error);
					this.$message.error('删除失败');
				}
			},

			handleTransferRowClick(row) {
				this.$refs.transferTable.toggleRowSelection(row);
			},

			//状态显示方法
			getTransferStatusType(state) {
				const stateStr = String(state);
				const typeMap = {
					'0': 'info', // 草稿
					'2': 'primary', // 已提交
					'4': 'warning', // 已审核
					'5': 'success', // 已过单
					'6': 'danger' // 已冲销
				};
				return typeMap[stateStr] || 'info';
			},

			// 修改 getDialogTitle 方法
			safeGetTitle() {
				try {
					if (!this.currentTransferRow) {
						return '新建出库单';
					}

					const titles = {
						'add': '新增出库入库',
						'edit': '修改出库单',
						'view': '查看出库单',
						'submit': '提交出库单',
						'aduit': '审核出库单',
						'pass': '过单出库单',
						'resave': '冲销出库单'
					};

					const baseTitle = titles[this.dialogMode] || '出库单';
					const docNum = this.currentTransferRow.docNum || '';

					return docNum ? `${baseTitle} - ${docNum}` : baseTitle;
				} catch (error) {
					console.log('获取标题出错，使用默认标题');
					return '出库单';
				}
			},
			/* 获取选中的出库方式名称 */
			getSelectedRetnTypeName(retnTypeId) {
				if (!retnTypeId) return '';
				const retnType = this.retnTypeOptions.find(item => item.id === retnTypeId);
				return retnType ? retnType.name : '';
			},

			/* 获取选中的供货单位名称 */
			getSelectedSupplierName(supplierId) {
				if (!supplierId) return '';
				const supplier = this.supplierOptions.find(item => item.id === supplierId);
				return supplier ? supplier.name : '';
			},
			// 加载药品选项
			async loadDrugOptions() {
				try {
					this.goodsListLoading = true;
					const params = {
						pageNum: 1,
						pageSize: 1000,
						drugName: this.searchQuery
					};

					let response;
					response = await ZYFselectDrug(params);
					if (response.code === 200) {
						this.processDrugOptions(response.data);
					} else {
						this.$message.error('获取药品列表失败');
					}
				} catch (error) {
					console.error('获取药品选项失败:', error);
					this.$message.error('获取药品选项失败');
				} finally {
					this.goodsListLoading = false;
				}
			},

			// 处理药品选项数据
			processDrugOptions(data) {
				const dataList = data.content || data || [];
				const drugs = dataList.map(item => this.mapDrugData(item));

				// 按药品名称分组
				const grouped = {};
				drugs.forEach(drug => {
					if (!grouped[drug.drugName]) {
						grouped[drug.drugName] = [];
					}
					grouped[drug.drugName].push(drug);
				});

				// 转换为选项格式
				this.drugOptions = Object.keys(grouped).map(drugName => ({
					label: drugName,
					options: grouped[drugName].map(drug => {
						// 关键修改：value应该是批次号的唯一id
						const optionValue = drug.originalId || drug.id; // 使用原始ID

						return {
							...drug,
							value: optionValue, // 批次号的id
							label: this.getBatchOptionLabel(drug),
							drugName: drug.drugName,
							drugId: drug.drugId, // 药品ID
							originalId: drug.id, // 保存原始ID
							manuLotnum: drug.manuLotnum,
							manufacturer: drug.manufacturer || drug.prodentpName || '未知厂家'
						};
					})
				}));
			},

			// 修改：获取批次选项标签
			getBatchOptionLabel(item) {
				// 显示药品名称和批次号
				if (item.manuLotnum) {
					return `${item.drugName} - 批次: ${item.manuLotnum}`;
				} else {
					return `${item.drugName} - 无批次号`;
				}
			},

			// 映射药品数据
			mapDrugData(item) {
				if (this.transferForm.outWarehouse === 4) {
					// 中药房数据映射
					return {
						id: item.dugInvyId || item.id,
						originalId: item.dugInvyId || item.id,
						drugId: item.drugId,
						drugName: item.drugName,
						drugSpec: item.drugSpec,
						manuLotnum: item.manuLotnum,
						purcCnt: item.purcCnt,
						purcPric: item.purcPric,
						salePric: item.salePric,
						pacCnt: item.pacCnt || 1, // 确保有默认值
						pacUnt: item.pacUnt || '包装单位',
						dosUnt: item.dosUnt || '最小单位',
						supplierName: item.supplierName,
						manufacturer: item.manufacturer || item.prodentpName || item.supplierName,
						prodentpName: item.prodentpName || item.manufacturer || item.supplierName,
						expyDate: item.expyDate || item.validityDate || item.validUntil || '',
						manuDate: item.manuDate || item.productionDate || item.manufactureDate || ''
					};
				} else {
					// 中药房数据映射
					return {
						id: item.invyId || item.id,
						originalId: item.invyId || item.id,
						drugId: item.drugId,
						drugName: item.drugName,
						drugSpec: item.drugSpec,
						manuLotnum: item.manuLotnum,
						purcCnt: item.purcCnt,
						purcPric: item.purcPric,
						salePric: item.salePric,
						pacCnt: item.pacCnt || 1, // 确保有默认值
						pacUnt: item.pacUnt || '包装单位',
						dosUnt: item.dosUnt || '最小单位',
						supplierName: item.supplierName,
						manufacturer: item.manufacturer || item.prodentpName || item.supplierName,
						prodentpName: item.prodentpName || item.manufacturer || item.supplierName,
						expyDate: item.expyDate || item.validityDate || item.validUntil || '',
						manuDate: item.manuDate || item.productionDate || item.manufactureDate || ''
					};
				}
			},
			// 生成出库单号
			generateDocNum(outWarehouse) {
				const now = new Date();
				const timestamp = now.getTime();
				const dateStr = now.toISOString().slice(0, 10).replace(/-/g, '');

				if (outWarehouse === 4) {
					// 中药房：zyFDB + 日期 + 时间戳后6位
					return `zyFCK${dateStr}${timestamp.toString().slice(-6)}`;
				} else {
					return `CK${dateStr}${timestamp.toString().slice(-6)}`;
				}
			},

			// 补齐所有缺失的方法实现

			// 查找药品方法
			findDrugById(selectedId) {
				// 在药品选项中查找对应的药品信息
				for (const group of this.drugOptions) {
					const drug = group.options.find(opt => {
						// 关键修改：比较id，而不是value
						return opt.id === selectedId || opt.value === selectedId || opt.originalId === selectedId;
					});
					if (drug) return drug;
				}
				return null;
			},

			// 处理包装单位库存不足的情况
			async handlePackageUnitInsufficient(row, selectedDrug, validateResult) {
				try {
					const result = await this.$confirm(
						`药品 ${selectedDrug.drugName} 的包装单位默认出库数量为1库存不足，是否采用最小单位进行系统录入？`,
						'库存不足提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}
					);

					if (result) {
						// 用户确认采用最小单位
						row.purcType = 1; // 切换为最小单位
						row.currentUnit = selectedDrug.dosUnt || '最小单位';

						// 重新验证最小单位库存
						const minUnitResult = await this.validateGoodsStock(row, 1, 1);

						if (minUnitResult.code === 200) {
							// 最小单位库存充足
							row.validated = true;
							this.updateRowData(row, minUnitResult.data);
							this.calculateRowAmount(row);
							this.calculateTotals();
							this.$message.success(`药品 ${row.drugName} 已采用最小单位录入`);
						} else {
							// 最小单位也库存不足
							row.validated = false;
							row.validationError = '最小单位库存也不足';
							this.$message.error(`药品 ${row.drugName} 最小单位库存也不足`);
							// 重置选择
							this.resetRowData(row);
						}
					} else {
						// 用户取消，重置选择
						this.resetRowData(row);
						this.$message.info('已取消选择该药品');
					}
				} catch (error) {
					// 用户点击取消或关闭对话框
					if (error !== 'cancel') {
						console.error('处理库存不足失败:', error);
						this.$message.error('处理失败');
					}
					// 重置选择
					this.resetRowData(row);
				}
			},

			// 更新行数据
			updateRowData(row, newData) {
				if (!newData) return;

				// 更新库存相关数据
				if (newData.maxQuantity !== undefined) {
					row.maxQuantity = newData.maxQuantity;
				}

				if (newData.realPurcCnt !== undefined) {
					row.realPurcCnt = newData.realPurcCnt;
				}

				// 根据当前库存类型更新单价
				if (row.purcType === 1) {
					// 最小单位
					if (newData.minPurcPric !== undefined) {
						row.purcPric = newData.minPurcPric;
					}
					if (newData.minSalePric !== undefined) {
						row.salePric = newData.minSalePric;
					}
				} else {
					// 包装单位
					if (newData.purcPric !== undefined) {
						row.purcPric = newData.purcPric;
					}
					if (newData.salePric !== undefined) {
						row.salePric = newData.salePric;
					}
				}

				// 如果接口返回了金额，直接使用接口返回的金额
				if (newData.purcAmt !== undefined) {
					row.purcAmt = Number(newData.purcAmt).toFixed(2);
				}

				if (newData.saleAmt !== undefined) {
					row.saleAmt = Number(newData.saleAmt).toFixed(2);
				}
			},

			// 计算单行金额
			calculateRowAmount(row) {
				if (!row.apllyAmt || row.apllyAmt <= 0) {
					row.purcAmt = '0.00';
					row.saleAmt = '0.00';
					return;
				}

				const quantity = Number(row.apllyAmt);
				const costPrice = Number(row.purcPric || 0);
				const salePrice = Number(row.salePric || 0);

				// 计算成本金额
				row.purcAmt = (quantity * costPrice).toFixed(2);

				// 计算零售金额
				row.saleAmt = (quantity * salePrice).toFixed(2);
			},

			// 计算合计金额
			calculateTotals() {
				let totalCost = 0;
				let totalSale = 0;

				this.transferGoods.forEach(item => {
					const cost = parseFloat(item.purcAmt || 0);
					const sale = parseFloat(item.saleAmt || 0);

					if (!isNaN(cost)) totalCost += cost;
					if (!isNaN(sale)) totalSale += sale;
				});

				this.cbValue = totalCost.toFixed(2);
				this.lsValue = totalSale.toFixed(2);
			},

			// 获取库存显示文本
			getStockDisplayText(row) {
				const stock = parseFloat(row.realPurcCnt || row.purcCnt || 0);

				if (isNaN(stock)) {
					return '0';
				}

				// 如果是包装单位，显示为"包装单位数量 + 最小单位数量"格式
				if (row.purcType === 2) {
					const pacCnt = row.pacCnt || 1;
					const packageUnits = Math.floor(stock);
					const minUnits = Math.round((stock - packageUnits) * pacCnt);

					if (packageUnits > 0 && minUnits > 0) {
						return `${packageUnits}${this.getUnitName(row, 'pac')}${minUnits}${this.getUnitName(row, 'min')}`;
					} else if (packageUnits > 0) {
						return `${packageUnits}${this.getUnitName(row, 'pac')}`;
					} else if (minUnits > 0) {
						return `${minUnits}${this.getUnitName(row, 'min')}`;
					} else {
						return '0';
					}
				} else {
					// 最小单位直接显示
					return `${stock}${this.getUnitName(row, 'min')}`;
				}
			},

			// 获取单位名称
			getUnitName(row, unitType) {
				if (unitType === 'pac') {
					return row.pacUnt || row.pacUntName || '包装单位';
				} else {
					return row.dosUnt || row.minUntName || '最小单位';
				}
			},

			// 验证行库存
			async validateRowStock(row) {
				if (!row.drugId) {
					row.validated = false;
					row.validationError = '请先选择药品';
					this.updateSubmitButtonState();
					return;
				}

				if (!row.apllyAmt || row.apllyAmt < 1) {
					row.validated = false;
					row.validationError = '申请出库数量必须大于0';
					this.updateSubmitButtonState();
					return;
				}

				try {
					row.validating = true;
					row.validationError = '';

					const validateResult = await this.validateGoodsStock(
						row,
						row.purcType,
						row.apllyAmt
					);

					if (validateResult.code === 200) {
						row.validated = true;
						this.updateRowData(row, validateResult.data);
						this.calculateRowAmount(row);
						this.calculateTotals();
					} else {
						row.validated = false;
						row.validationError = validateResult.message || '库存验证失败';
					}
				} catch (error) {
					console.error('库存验证失败:', error);
					row.validated = false;
					row.validationError = '验证失败';
				} finally {
					row.validating = false;
					this.updateSubmitButtonState();
				}
			},

			// 验证药品库存方法
			async validateGoodsStock(goods, purcType = 2, allotNum = 1) {
				try {
					// 参数验证
					if (allotNum < 1) {
						return {
							code: 400,
							message: '申请出库数量不能小于1'
						};
					}

					// 根据出库药库确定allocateType
					const allocateType = this.transferForm.outWarehouse === 4 ? 2 : 1;

					// 关键修改：正确获取药品ID
					let drugId = goods.id; // 直接使用药品ID，而不是goods.id

					// 如果drugId不存在，尝试从其他字段获取
					if (!drugId) {
						// 尝试从药品选项中查找对应的ID
						const foundDrug = this.findDrugById(goods.id);
						if (foundDrug) {
							drugId = foundDrug.id;
						} else {
							drugId = goods.id; // 回退到goods.id
						}
					}

					if (!drugId) {
						return {
							code: 400,
							message: '药品ID不能为空'
						};
					}

					const params = {
						amount: allotNum,
						purcType: purcType,
						invId: drugId, // 使用正确的药品ID
						allocateType: allocateType
					};

					console.log('调用ZYFdugRetnJoin接口验证库存:', params, {
						drugName: goods.drugName,
						drugId: drugId,
						goodsId: goods.id
					});

					const result = await ZYFdugRetnJoin(params);

					if (result.code === 200) {
						return {
							code: 200,
							data: {
								maxQuantity: result.data.maxQuantity || result.data.purcCnt || 0,
								realPurcCnt: result.data.realPurcCnt || result.data.purcCnt || 0,
								minPurcPric: result.data.minPurcPric || goods.originalPurcPric || 0,
								minSalePric: result.data.minSalePric || goods.originalSalePric || 0,
								purcPric: result.data.purcPric || (goods.originalPurcPric || 0) * (goods.pacCnt || 1),
								salePric: result.data.salePric || (goods.originalSalePric || 0) * (goods.pacCnt || 1)
							}
						};
					} else {
						return {
							code: result.code,
							message: result.message || '库存验证失败'
						};
					}
				} catch (error) {
					console.error('调用ZYFdugRetnJoin接口失败:', error);
					return {
						code: 500,
						message: '库存验证失败'
					};
				}
			},

			// 数量输入处理
			async handleQuantityInput(row) {
				// 清除防抖定时器
				if (this.debounceTimers[row.id]) {
					clearTimeout(this.debounceTimers[row.id]);
				}

				// 设置新的防抖定时器
				this.debounceTimers[row.id] = setTimeout(() => {
					this.validateRowStock(row);
				}, 500);
			},

			// 数量失去焦点处理
			async handleQuantityBlur(row) {
				await this.validateRowStock(row);
			},

			// 处理出库药库变化事件
			async handleOutWarehouseChange(value) {
				// 修改：使用phayId而不是outWarehouse
				if (this.transferGoods.length > 0) {
					try {
						const oldWarehouse = this.transferForm.phayId;
						const newWarehouse = value;

						const getWarehouseName = (warehouseId) => {
							const warehouse = this.warehouseOptions.find(item => item.value === warehouseId);
							return warehouse ? warehouse.label : '未知药库';
						};

						const oldName = getWarehouseName(oldWarehouse);
						const newName = getWarehouseName(newWarehouse);

						await this.$confirm(
							`当前出库明细表中已存在${oldName}的数据，切换出库药库为${newName}将清空现有数据，是否确认继续？`,
							'切换出库药库提示', {
								confirmButtonText: '确认清空并切换',
								cancelButtonText: '取消切换',
								type: 'warning'
							}
						);

						this.transferGoods = [];
						this.calculateTotals();
						this.updateSubmitButtonState();
						this.$message.info('已清空出库药品列表');

					} catch (error) {
						this.$nextTick(() => {
							this.transferForm.phayId = this.oldOutWarehouse;
						});
						return;
					}
				}

				this.oldOutWarehouse = this.transferForm.phayId;

				// 重新生成出库单号
				this.transferForm.docNum = this.generateDocNum(value);

				// 重新加载药品选项
				this.loadDrugOptions();
			},

			// 回车添加功能变化处理
			handleEnterAddChange(checked) {
				if (checked) {
					this.$message.success('已开启回车添加功能，在模态框区域按回车键可添加新行');
					// 如果对话框已打开，重新绑定事件
					if (this.dialogVisible && !this.isReadonlyMode) {
						this.bindEnterKey();
					}
				} else {
					this.$message.info('已关闭回车添加功能');
					this.unbindEnterKey();

					// 清除所有相关状态和定时器
					this.cleanupEnterKeyState();
				}
			},

			// 新增：清理回车键相关状态
			cleanupEnterKeyState() {
				// 清除所有定时器
				if (this.enterKeyDebounceTimer) {
					clearTimeout(this.enterKeyDebounceTimer);
					this.enterKeyDebounceTimer = null;
				}

				if (this.feedbackTimer) {
					clearTimeout(this.feedbackTimer);
					this.feedbackTimer = null;
				}

				// 重置所有状态
				this.isProcessingEnterKey = false;
				this.isShowingFeedback = false;
			},

			// 模态框键盘事件处理
			handleDialogKeydown(event) {
				// 只在启用回车添加功能且不是只读模式时处理
				if (!this.enableEnterAdd || this.isReadonlyMode) return;

				// 检查是否按下了回车键
				if (event.key === 'Enter') {
					// 检查是否在输入框中，避免冲突
					const target = event.target;
					if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') {
						return;
					}

					event.preventDefault();
					this.addSingleRow();
				}
			},

			// 模态框关闭处理
			handleSimpleClose() {
				console.log('模态框关闭，解绑回车键事件');
				this.unbindEnterKey();
				this.dialogVisible = false;
			},

			// 打开模态框方法
			handleCreateTransfer() {
				this.dialogMode = 'add';
				this.resetForm();
				this.dialogVisible = true;

				// 加载药品选项
				this.loadDrugOptions();

				// 绑定回车键事件
				this.$nextTick(() => {
					this.bindEnterKey();
				});
			},

			handleEditTransfer(row) {
				this.dialogMode = 'edit';
				this.currentTransferRow = row;
				this.dialogVisible = true;
				this.loadTransferDetail(row.id);

				// 加载药品选项
				this.loadDrugOptions();

				// 绑定回车键事件
				this.$nextTick(() => {
					this.bindEnterKey();
				});
			},

			handleViewTransfer(row) {
				this.dialogMode = 'view';
				this.currentTransferRow = row;
				this.dialogVisible = true;
				this.loadTransferDetail(row.id);

				// 查看模式不需要绑定回车键
			},

			// 重置表单
			resetForm() {
				const currentDate = new Date();
				const formattedDate = currentDate.toISOString().split('T')[0];

				let userInfo = {};
				try {
					userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
				} catch (error) {
					console.error('解析用户信息失败:', error);
				}

				this.transferForm = {
					phayId: 4,
					busDate: formattedDate,
					docNum: this.generateDocNum(1),
					createName: userInfo.staffName || 'admin',
					supplyCandidateId: null,
					retnTypeId: 1, // 重置为默认值1
					retnTypeName: '采购退库', // 重置为默认名称
					remarks: ''
				};

				this.transferGoods = [];
				this.cbValue = '0.00';
				this.lsValue = '0.00';
				this.updateSubmitButtonState();
			},

			/* 修改：从详情数据填充表单 */
			fillFormFromDetail(detailData) {
				// 填充基本信息
				this.transferForm = {
					phayId: detailData.phayId || detailData.shedId || 4,
					busDate: detailData.invoDate || new Date().toISOString().split('T')[0],
					docNum: detailData.purcInvoCodg || '',
					createName: detailData.createName || 'admin',
					supplyCandidateId: detailData.supplyCandidateId || null,
					supplierName: detailData.supplierName || '',
					retnTypeId: detailData.retnTypeId || 1, // 默认设置为1
					retnTypeName: detailData.retnTypeName || '采购退库',
					remarks: detailData.remarks || ''
				};

				// 填充药品列表
				this.transferGoods = [];
				if (detailData.list && Array.isArray(detailData.list)) {
					// 先加载药品选项，确保选项数据可用
					this.$nextTick(() => {
						detailData.list.forEach(item => {
							const newRow = {
								id: item.id || item.drugId, // 关键修改：使用药品ID作为下拉选项的value
								drugId: item.drugId,
								drugName: item.drugName,
								drugSpec: item.drugSpec,
								apllyAmt: item.apllyAmt || 1,
								purcType: item.purcType || 2,
								purcPric: item.purcPric || item.retnPric || 0,
								salePric: item.salePric || 0,
								purcAmt: item.purcAmt || item.retnAmt || '0.00',
								saleAmt: item.saleAmt || '0.00',

								manuLotnum: item.manuLotnum || '',
								manuDate: item.manuDate || '',
								expyDate: item.expyDate || '',
								prodentpName: item.prodentpName || '',
								supplierName: item.supplierName || '',

								validated: true,
								currentUnit: item.unt || (item.purcType === 1 ? '最小单位' : '包装单位')
							};
							this.transferGoods.push(newRow);
						});

						// 确保药品下拉选项正确显示
						this.ensureDrugOptionsDisplay();
					});
				}

				this.calculateTotals();
				this.updateSubmitButtonState();
			},
			/* 新增：确保药品选项正确显示 */
			ensureDrugOptionsDisplay() {
				this.$nextTick(() => {
					this.transferGoods.forEach(row => {
						if (row.id) {
							// 查找对应的药品选项，确保显示正确
							const drug = this.findDrugById(row.id);
							if (drug) {
								// 更新行的显示信息
								row.drugName = drug.drugName || row.drugName;
								row.drugSpec = drug.drugSpec || row.drugSpec;
							}
						}
					});
				});
			},

			// 加载出库详情
			async loadTransferDetail(id) {
				try {
					this.goodsListLoading = true;
					const response = await ZYFgetDrugRetnList({
						id: id
					});

					if (response.code === 200 && response.data) {
						this.fillFormFromDetail(response.data);
					} else {
						this.$message.error('获取出库详情失败');
					}
				} catch (error) {
					console.error('加载出库详情失败:', error);
					this.$message.error('加载出库详情失败');
				} finally {
					this.goodsListLoading = false;
				}
			},

			// 提交出库单（新增）
			async submitTransfer() {
				if (this.isEditingRow) {
					this.$message.warning('请先完成药品信息的编辑');
					return;
				}

				if (this.transferGoods.length === 0) {
					this.$message.warning('请至少添加一个出库药品');
					return;
				}

				// 验证必填字段
				if (!this.transferForm.supplyCandidateId) {
					this.$message.warning('请选择供货单位');
					return;
				}

				// 验证出库方式
				if (!this.transferForm.retnTypeId) {
					this.$message.warning('请选择出库方式');
					return;
				}

				const invalidGoods = this.transferGoods.filter(item => !this.isRowValid(item));
				if (invalidGoods.length > 0) {
					this.$message.warning('请先完成所有药品的验证');
					return;
				}

				try {
					// 构建list参数
					const list = this.transferGoods.map(item => {
						return {
							apllyAmt: parseInt(item.apllyAmt) || 0,
							drugId: item.drugId || 0,
							drugName: item.drugName || '',
							drugSpec: item.drugSpec || '',
							invId: item.id || item.drugId || 0,
							manuLotnum: item.manuLotnum || '',
							prodentpName: item.prodentpName || '',
							prodentpNameId: 0,
							purcType: parseInt(item.purcType) || 2,
							retnAmt: parseFloat(item.purcAmt) || 0,
							retnPric: parseFloat(item.purcPric) || 0,
							saleAmt: parseFloat(item.saleAmt) || 0,
							salePric: parseFloat(item.salePric) || 0,
							unt: item.currentUnit || (item.purcType === 1 ? '最小单位' : '包装单位')
						};
					});

					// 按照新格式构建提交数据
					const submitData = {
						costAmt: parseFloat(this.cbValue) || 0,
						list: list,
						phayId: this.transferForm.phayId || 4,
						remarks: this.transferForm.remarks || '',
						retnTypeId: this.transferForm.retnTypeId || 0, // 使用选择的出库方式ID
						saleAmt: parseFloat(this.lsValue) || 0,
						state: 0,
						supplyCandidateId: this.transferForm.supplyCandidateId || 0
					};

					console.log('提交出库单数据:', submitData);

					const result = await ZYFAddReturn(submitData);

					if (result.code === 200) {
						this.$message.success('出库单提交成功');
						this.dialogVisible = false;
						this.resetForm();
						this.loadTransferData();
					} else {
						this.$message.error(result.message || '提交失败');
					}
				} catch (error) {
					console.error('提交出库单失败:', error);
					this.$message.error('提交失败');
				}
			},

			/* 修改：提交出库单（编辑） */
			async submitEditTransfer() {
				if (this.transferGoods.length === 0) {
					this.$message.warning('请至少添加一个出库药品');
					return;
				}

				if (this.isEditingRow) {
					this.$message.warning('请先完成药品信息的编辑');
					return;
				}

				// 验证必填字段
				if (!this.transferForm.supplyCandidateId) {
					this.$message.warning('请选择供货单位');
					return;
				}

				if (!this.transferForm.retnTypeId) {
					this.$message.warning('请选择出库方式');
					return;
				}

				try {
					const list = this.transferGoods.map(item => {
						return {
							apllyAmt: parseInt(item.apllyAmt) || 0,
							drugId: item.drugId || 0,
							drugName: item.drugName || '',
							drugSpec: item.drugSpec || '',
							invId: item.id || item.drugId || 0,
							manuLotnum: item.manuLotnum || '',
							prodentpName: item.prodentpName || '',
							prodentpNameId: 0,
							purcType: parseInt(item.purcType) || 2,
							retnAmt: parseFloat(item.purcAmt) || 0,
							retnPric: parseFloat(item.purcPric) || 0,
							saleAmt: parseFloat(item.saleAmt) || 0,
							salePric: parseFloat(item.salePric) || 0,
							unt: item.currentUnit || (item.purcType === 1 ? '最小单位' : '包装单位')
						};
					});

					const submitData = {
						id: this.currentTransferRow.id,
						costAmt: parseFloat(this.cbValue) || 0,
						list: list,
						phayId: this.transferForm.phayId || 4,
						remarks: this.transferForm.remarks || '',
						retnTypeId: this.transferForm.retnTypeId || 0, // 使用选择的出库方式ID
						saleAmt: parseFloat(this.lsValue) || 0,
						state: 0,
						supplyCandidateId: this.transferForm.supplyCandidateId || 0
					};

					const result = await ZYFEditReturn(submitData);

					if (result.code === 200) {
						this.$message.success('出库单修改成功');
						this.dialogVisible = false;
						this.resetForm();
						this.loadTransferData();
					} else {
						this.$message.error(result.message || '修改失败');
					}
				} catch (error) {
					console.error('修改出库单失败:', error);
					this.$message.error('修改失败');
				}
			},

			// 加载出库数据
			async loadTransferData(params = {}) {
				// 防重复请求检查
				const now = Date.now();
				if (this.isTableLoading || (now - this.lastLoadTime < this.loadDebounce)) {
					console.log('数据加载请求被跳过，防止重复请求');
					return;
				}

				this.isTableLoading = true;
				this.lastLoadTime = now;
				this.transferTableLoading = true;

				try {
					const requestParams = {
						pageNum: this.transferPagination.currentPage,
						pageSize: this.transferPagination.pageSize,
						state: params.state !== undefined ? params.state : this.state,
						startDate: params.startDate !== undefined ? params.startDate : this.startDate,
						endDate: params.endDate !== undefined ? params.endDate : this.endDate,
						documentNo: params.documentNo !== undefined ? params.documentNo : this.documentNo
					};

					// 确保日期参数不为undefined
					if (!requestParams.startDate) {
						const today = new Date();
						requestParams.startDate =
							`${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')} 00:00:00`;
					}

					if (!requestParams.endDate) {
						const today = new Date();
						requestParams.endDate =
							`${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')} 23:59:59`;
					}

					const response = await ZYdugRetnPage(requestParams);
					this.transferTableData = response.data.content || [];
					this.transferPagination.total = response.data.totalSize || 0;
					this.updateTotalData();

				} catch (error) {
					console.error('获取出库数据失败:', error);
					this.$message.error('获取出库数据失败');
				} finally {
					this.transferTableLoading = false;
					this.isTableLoading = false;
				}
			},

			// 更新统计数据
			updateTotalData() {
				let totalCost = 0;
				let totalSale = 0;
				let totalMedicineCount = 0;

				this.transferTableData.forEach(item => {
					totalCost += Number(item.costAmt || 0);
					totalSale += Number(item.saleAmt || 0);
					totalMedicineCount += Number(item.medicineCount || 0);
				});

				this.totalData = {
					transferCount: this.transferTableData.length,
					medicineCount: totalMedicineCount,
					totalAmount: totalCost.toFixed(2)
				};
			},

			// 表格事件处理
			handleTransferSelectionChange(selection) {
				this.selectedTransferRows = selection;
			},

			handleTransferSizeChange(size) {
				this.transferPagination.pageSize = size;
				this.transferPagination.currentPage = 1;
				this.loadTransferData();
			},

			handleTransferCurrentChange(page) {
				this.transferPagination.currentPage = page;
				this.loadTransferData();
			},

			handleTransferFilterChange() {
				this.transferPagination.currentPage = 1;
				this.loadTransferData();
			},

			// 其他操作按钮方法
			async handleSubmitTransfer(row) {
				try {
					this.$confirm('确定要提交此出库单吗？', '提交确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						const result = await ZYFtoExamine({
							id: row.id,
							state: 2 // 提交状态
						});

						if (result.code === 200) {
							this.$message.success('出库单提交成功');
							this.loadTransferData(); // 刷新表格数据
						} else {
							this.$message.error(result.message || '提交失败');
						}
					});
				} catch (error) {
					console.error('提交出库单失败:', error);
					this.$message.error('提交失败');
				}
			},

			/* 修改：审核出库单 */
			async handleAuditTransfer(row) {
				try {
					this.$confirm('确定要审核通过此出库单吗？', '审核确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						const result = await ZYFtoExamine({
							id: row.id,
							state: 4 // 审核状态
						});

						if (result.code === 200) {
							this.$message.success('出库单审核成功');
							this.loadTransferData();
						} else {
							this.$message.error(result.message || '审核失败');
						}
					});
				} catch (error) {
					console.error('审核出库单失败:', error);
					this.$message.error('审核失败');
				}
			},

			/* 修改：驳回出库单 */
			async handleRejectTransfer(row) {
				try {
					this.$confirm('确定要驳回此出库单吗？', '驳回确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						// 驳回通常是将状态改回草稿状态(0)或其他特定状态
						const result = await ZYFtoExamine({
							id: row.id,
							state: 0 // 驳回到草稿状态，根据实际需求调整
						});

						if (result.code === 200) {
							this.$message.success('出库单驳回成功');
							this.loadTransferData();
						} else {
							this.$message.error(result.message || '驳回失败');
						}
					});
				} catch (error) {
					console.error('驳回出库单失败:', error);
					this.$message.error('驳回失败');
				}
			},

			/* 修改：过单出库单 */
			async handlePassTransfer(row) {
				try {
					this.$confirm('确定要过单此出库单吗？', '过单确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						const result = await ZYFtoExamine({
							id: row.id,
							state: 5 // 过单状态
						});

						if (result.code === 200) {
							this.$message.success('出库单过单成功');
							this.loadTransferData();
						} else {
							this.$message.error(result.message || '过单失败');
						}
					});
				} catch (error) {
					console.error('过单出库单失败:', error);
					this.$message.error('过单失败');
				}
			},

			/* 修改：冲销出库单 */
			async handleReverseTransfer(row) {
				try {
					this.$confirm('确定要冲销此出库单吗？冲销后将无法恢复', '冲销确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						const result = await ZYFtoExamine({
							id: row.id,
							state: 6 // 冲销状态
						});

						if (result.code === 200) {
							this.$message.success('出库单冲销成功');
							this.loadTransferData();
						} else {
							this.$message.error(result.message || '冲销失败');
						}
					});
				} catch (error) {
					console.error('冲销出库单失败:', error);
					this.$message.error('冲销失败');
				}
			},

			/* 修改：删除出库单 */
			async handleDeleteTransfer(row) {
				try {
					this.$confirm('确定要删除此出库单吗？', '删除确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						// 调用删除接口
						const result = await ZYFdeleteRetn({
							id: row.id
						});

						if (result.code === 200) {
							this.$message.success('出库单删除成功');
							this.loadTransferData();
						} else {
							this.$message.error(result.message || '删除失败');
						}
					});
				} catch (error) {
					console.error('删除出库单失败:', error);
					this.$message.error('删除失败');
				}
			},

			// 状态变化处理
			async handleStateChange() {
				try {
					let confirmMessage = '';
					let targetState = 0;

					// 根据当前对话框模式确定操作
					switch (this.dialogMode) {
						case 'submit':
							confirmMessage = '确定要提交审核此出库单吗？';
							targetState = 2;
							break;
						case 'aduit':
							confirmMessage = '确定要审核通过此出库单吗？';
							targetState = 4;
							break;
						case 'pass':
							confirmMessage = '确定要过单此出库单吗？';
							targetState = 5;
							break;
						case 'resave':
							confirmMessage = '确定要冲销此出库单吗？';
							targetState = 6;
							break;
						default:
							this.$message.warning('未知的操作类型');
							return;
					}

					this.$confirm(confirmMessage, '操作确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						const result = await ZYFtoExamine({
							id: this.currentTransferRow.id,
							state: targetState
						});

						if (result.code === 200) {
							this.$message.success('操作成功');
							this.dialogVisible = false;
							this.loadTransferData(); // 刷新表格数据
						} else {
							this.$message.error(result.message || '操作失败');
						}
					});
				} catch (error) {
					console.error('状态变更操作失败:', error);
					this.$message.error('操作失败');
				}
			},

			// 页面大小变化
			handlePageChange(page) {
				this.currentPage = page;
				this.loadGoodsList();
			},

			// 获取主表格输入框类名
			getMainTableInputClass(row) {
				if (row.validating) {
					return 'validating-input';
				} else if (row.validated === false) {
					return 'validation-error-input';
				}
				return '';
			},
		}
	}
</script>

<style lang="less" scoped>
	.all-cate-zy {
		height: 100%;
		padding: 12px;
		display: flex;
		flex-direction: column;

		.operation-buttons {
			margin-bottom: 16px;

			.el-button {
				margin-right: 10px;
			}
		}

		.data-section {
			flex: 1;
			display: flex;
			flex-direction: column;
		}

		// 优化表格样式
		.table-scroll-wrapper {
			border: 1px solid #ebeef5;
			border-radius: 4px;
			overflow: hidden;

			.table-scroll-container {
				overflow-x: auto;
			}

			/* 包装数量提示样式 */
			.package-hint {
				font-size: 11px;
				color: #909399;
				margin-top: 2px;
				padding: 1px 4px;
				background: #f5f7fa;
				border-radius: 2px;
				display: inline-block;
			}
		}

		// 药品选择器样式优化
		:deep(.el-select) {
			width: 100%;

			.el-select__tags {
				max-width: 100%;
			}

			// 批次选项内容样式
			.batch-option-content {
				display: flex;
				justify-content: space-between;
				width: 100%;
				padding: 4px 0;
				font-size: 12px;
				line-height: 1.4;

				.batch-info,
				.manufacturer-info {
					display: flex;
					flex-direction: column;
					flex: 1;
				}

				.batch-label,
				.manufacturer-label {
					color: #909399;
					font-weight: 500;
					margin-bottom: 2px;
				}

				.batch-value,
				.manufacturer-value {
					color: #606266;
					word-break: break-all;
				}

				.batch-info {
					margin-right: 8px;
					border-right: 1px solid #ebeef5;
					padding-right: 8px;
				}

				.manufacturer-info {
					margin-left: 8px;
				}
			}

			// 药品标题选项样式
			.drug-title-option {
				background-color: #f5f7fa !important;
				font-weight: bold !important;
				color: #409EFF !important;
				cursor: default !important;
				height: auto !important;
				line-height: 1.5 !important;
				padding: 8px 20px !important;

				&:hover {
					background-color: #f5f7fa !important;
				}

				.el-select-dropdown__item.selected {
					background-color: #f5f7fa !important;
					color: #409EFF !important;
				}
			}
		}

		// 数量输入框样式
		.quantity-edit-cell {
			display: flex;
			flex-direction: column;
			align-items: center;

			.edit-input-group {
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.validation-error {
				color: #f56c6c;
				font-size: 12px;
				margin-top: 4px;
			}
		}

		.quantity-display {
			font-weight: 500;
			color: #606266;
		}

		.quantity-unit {
			color: #909399;
			font-size: 12px;
			margin-left: 4px;
		}

		// 回车添加复选框样式
		.row-info {
			display: flex;
			align-items: center;
			gap: 16px;
			margin-top: 8px;

			.el-checkbox {
				margin-right: 0;
			}
		}

		// 响应式设计
		@media (max-width: 768px) {
			padding: 8px;

			.operation-buttons {
				flex-direction: column;
				gap: 8px;

				.el-button {
					margin-right: 0;
					margin-bottom: 8px;
					width: 100%;
				}
			}

			.row-info {
				flex-direction: column;
				align-items: flex-start;
				gap: 8px;
			}

			// 移动端批次选项样式调整
			:deep(.batch-option-content) {
				flex-direction: column;

				.batch-info {
					margin-right: 0;
					border-right: none;
					padding-right: 0;
					margin-bottom: 4px;
				}

				.manufacturer-info {
					margin-left: 0;
				}
			}
		}
	}

	// 模态框样式优化
	.transfer-dialog {
		:deep(.el-dialog) {
			border-radius: 8px;

			&__body {
				padding: 20px;
				max-height: 70vh;
				overflow-y: auto;
			}
		}

		.section-title {
			font-size: 16px;
			font-weight: 600;
			color: #303133;
			margin-bottom: 16px;
			padding-bottom: 8px;
			border-bottom: 2px solid #409eff;
		}

		.form-row {
			display: flex;
			gap: 20px;
			margin-bottom: 16px;

			.form-item {
				flex: 1;

				.form-label {
					display: block;
					margin-bottom: 6px;
					color: #606266;
					font-weight: 500;
				}
			}
		}

		.feets {
			margin-top: 20px;
			padding-top: 16px;
			border-top: 1px solid #ebeef5;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.total-amount {
				display: flex;
				align-items: center;
				gap: 8px;

				.el-input {
					width: 120px;
				}
			}

			.action-buttons {
				display: flex;

				.el-button {
					margin-left: 10px;
				}
			}
		}
	}
</style>